import { render, staticRenderFns } from "./CompanyRegister.vue?vue&type=template&id=6b35e3f7&scoped=true&"
import script from "../../services/company/company-register.js?vue&type=script&lang=js&"
export * from "../../services/company/company-register.js?vue&type=script&lang=js&"
import style0 from "@/assets/css/company.css?vue&type=style&index=0&id=6b35e3f7&scoped=true&lang=css&"
import style1 from "./CompanyRegister.vue?vue&type=style&index=1&id=6b35e3f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b35e3f7",
  null
  
)

export default component.exports